import axios from 'axios';

const BASE_URL = 'https://ai.kesifaraci.com/service/api';


axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const login = async (email, password) => {
    try {
        const response = await axios.post(`${BASE_URL}/auth/login`, { email, password });
        return response.data;
    } catch (error) {
        console.error("Login failed:", error.message);
        throw error; 
    }
};

export const register = async (data) => {
    try {
        const response = await axios.post(`${BASE_URL}/users/userCreate`, data);
        return response.data;
    } catch (error) {
        console.error("Registration failed:", error.message);
        throw error;
    }
};

export const userActivation = async (activationtoken) => {
    try {
        const response = await axios.get(`${BASE_URL}/users/userActivation/${activationtoken}`);
        return response.data;
    } catch (error) {
        console.error("Registration failed:", error.message);
        throw error;
    }
};



export const logout = (updateUserData) => {
    updateUserData('', '', '', '');

    delete axios.defaults.headers.common['Authorization'];

};

